<template>
  <div class='mmc_con'>
    <div class='block1 text_center'>
      <img alt='' height='220' src='@/assets/icons/Group2@2x(1).png' width='220' />
      <h3>{{ $t('reading.talkingPen.title') }}</h3>
      <div class='text'>{{ $t('reading.talkingPen.desc') }}</div>
      <div class='play_btn' @click='watchVideo'></div>
      <i></i>
      <p>{{ $t('reading.talkingPen.video') }}</p>
    </div>
    <div class='block2 w_1200 pos_r'>
      <h3 class='text_center'>{{ $t('reading.talkingPen.introTitle') }}</h3>
      <div class='text text_center'>{{ $t('reading.talkingPen.introDesc') }}</div>
      <div class='item_box'>
        <div class='img_box pos_r img_box_b'>
          <img alt='' class='img' height='509' src='@/assets/icons/Group3@2x(2).png' width='938'>
          <img alt='' class='bg1' height='218' src='@/assets/icons/pen_bg1.png' width='327'>
        </div>
        <div class='img_box fz_0 img_list'>
          <img alt='' class='img' height='380' src='@/assets/icons/Group4@2x(1).png' width='380'>
          <img alt='' class='img' height='380' src='@/assets/icons/Group5@2x.png' width='380'>
          <img alt='' class='img' height='380' src='@/assets/icons/Group8@2x.png' width='380'>
        </div>
        <div class='img_box pos_r'>
          <img alt='' class='img' height='380' src='@/assets/icons/IMG_1686@2x.png' width='380'>
          <img alt='' class='bg2' height='264' src='@/assets/icons/OvalCopy2@2x.png' width='264'>
        </div>
      </div>
      <div class='text_center'>
        <a class='more more2' href='#'>{{ $t('reading.talkingPen.more') }}</a>
      </div>
      <img alt='' class='bg3' height='186' src='@/assets/icons/TriangleCopy3@2x.png' width='226'>
    </div>
    <video-modal :show='showVideo'
                 video-url='https://static.kdkts.com/hungrycaterpillar.mp4'
                 poster='https://1251912200.vod2.myqcloud.com/53abe01evodtransgzp1251912200/1bf6e9277447398156520492024/1531979373_965322438.100_0.jpg'
                 @close='closeVideo'
    ></video-modal>
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
import VideoModal from '@/components/VideoModal'

export default {
  name: 'TalkingPen',
  components: {
    VideoModal,
  },
  data () {
    return {
      showVideo: false,
    }
  },
  methods: {
    watchVideo () {
      this.showVideo = true
      setTimeout(() => {
        const ele = document.getElementById('video')
        if (mediaDevice() === 'mobile') {
          ele.requestFullscreen()
        }
        ele.play()
      }, 1000)
    },
    closeVideo () {
      this.showVideo = false
    },
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('reading.talkingPen.title')}`)
  },
}
</script>
